import React from "react";
import { Controller } from "react-hook-form";
import { Form } from "react-bootstrap";

import { ICheckboxProps } from "../interfaces";

const CheckboxCtrl = ({
	control,
	showError,
	placeholder,
	name,
	required,
	disabled,
	id,
	label,
	defaultValue,
	className = '',
	groupClassName = 'mb-3'
}: ICheckboxProps) => {
	const rules: any = {
		required: required,
	};
	return (
		<Controller
			rules={rules}
			name={name}
			control={control}
			render={({ field }) => (
				<>
					<Form.Group className={`form-check ${groupClassName}`}>
						<Form.Check
							{...field}
							id={id}
							disabled={disabled}
							placeholder={placeholder}
							type="checkbox"
							isInvalid={
								showError && showError(name) ? true : false
							}
							checked={field.value}
							defaultValue={defaultValue}
							className={className}
						/>
                        <Form.Label htmlFor={id}>
							{label}{" "}
							{required && <span className="text-danger">*</span>}
						</Form.Label>
						{showError && showError(name) ? (
							<Form.Control.Feedback
								type="invalid"
								className="d-block"
							>
								{showError(name)}
							</Form.Control.Feedback>
						) : null}
					</Form.Group>
				</>
			)}
		></Controller>
	);
};

export default CheckboxCtrl;
